<nb-list>
    <nb-list-item>
        <div class="item-label">Created</div>
        <div class="detail">{{numberOfArticles}}</div>
    </nb-list-item>
    <nb-list-item>
        <div class="item-label">Status</div>
        <div class="detail">{{numberOfArticles}}</div>
    </nb-list-item>
    <nb-list-item>
        <div class="item-label"># Articles</div>
        <div class="detail">{{numberOfArticles}}</div>
    </nb-list-item>
    <nb-list-item>
        <div class="item-label">Latest</div>
        <div class="detail">{{lastestArticle}}</div>
    </nb-list-item>       
</nb-list>


